import React from 'react';
import Typography from '@material-ui/core/Typography';
import Amplify, { Auth } from 'aws-amplify';
import {
	AmplifyAuthenticator,
	AmplifyContainer,
  AmplifySignIn,
} from '@aws-amplify/ui-react';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';
import awsconfig from './aws-exports';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import logo from './assets/ACES_Logo.png';
import ReviewDocuments from './ReviewDocuments';


Amplify.configure(awsconfig);

const useStyles = makeStyles((theme) => ({
  title: {
    paddingTop: theme.spacing(2)
  },
  logo: {
    maxWidth: 120,
  },
  titleBar: {
    flexGrow: 1,
    textAlign: 'center',
  },
  input: {
    display: 'none'
}
}));


function App() {
  const [authState, setAuthState] = React.useState();
	const [user, setUser] = React.useState();



	React.useEffect(() => {
		return onAuthUIStateChange((nextAuthState, authData) => {
			setAuthState(nextAuthState);
			setUser(authData);
		});
	}, []);

  const classes = useStyles();

  function signOut() {
    Auth.signOut()
      .then(() => {
        setAuthState("signout");
      })
      .catch(err => {
        console.log('err: ', err)
      })
  }

  return (
    <div>
      <AppBar position="static" style={{ background: '#333' }}>
        <Toolbar variant="dense">
          <img src={logo} alt="logo"  className={classes.logo}/>
          <Typography type="title" color="inherit" className={classes.titleBar}>
          Employee Portal
          </Typography>
          {(authState === AuthState.SignedIn && user) &&
            <Button edge="right" color="inherit" onClick={signOut}>
            Sign Out
          </Button>
        }
        </Toolbar>
    </AppBar>
      { (authState === AuthState.SignedIn && user)?
      <ReviewDocuments user={user}/>
      :
      <AmplifyContainer>
			  <AmplifyAuthenticator  style={{
                           '--amplify-primary-color': '#f89602',
                             '--amplify-primary-tint': '#69696e',
                          '--amplify-primary-shade': '#2e2e36',
                    }}>
          <AmplifySignIn slot="sign-in" hideSignUp ></AmplifySignIn>
        </AmplifyAuthenticator>
		  </AmplifyContainer>
      }
    </div>
  );
}

export default App;
